import React, { Component } from 'react';
import MealsListWrapper from './mealsList/MealsListWrapper';
import RouteTabs from '../../routeTabs/RouteTabs';
import MealsSelectionDialog from './mealsSelection/MealsSelectionDialog';
import MealsMobileProps from './MealsMobileProps';
import Dictionary from '../../../model/Dictionary';
import './MealsMobile.css';
import Constants from '../../../model/AppConfiguration';

export default class SeatsMobileScreen extends Component {
  static propTypes = MealsMobileProps;

  submitData = step => {
    this.props.submitFlights(Constants.REQUEST.MEALS, this.props.general, this.props.flights, step);
  };

  render () {
    const {
      routeId,
      routes,
      selectedRoute,
      selectedTrip,
      toggleRoutes,
      editOpened,
      selectedPassenger,
      openMealsSelection,
      closeMealsSelection,
    } = this.props;

    return (
      <div className='meals-mobile' id='mobile-container'>
        <h1>{Dictionary.meals.title}</h1>
        <RouteTabs
          centered
          showDate
          routes={routes}
          selectedTrip={selectedTrip}
          selectedRoute={selectedRoute}
          toggleRoutes={toggleRoutes}
          TabContent={
            <MealsListWrapper
              showOnlySelected
              routeId={routeId}
              onItemClickAction={openMealsSelection}
              selectedPassenger={selectedPassenger}
            />
          }
        />
        <MealsSelectionDialog
          selectedRoute={selectedRoute}
          editOpened={editOpened}
          handleClose={closeMealsSelection}
          selectedPassenger={selectedPassenger}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/meals/mobile/MealsMobileScreen.js